//@ts-nocheck
import mdsToken from '@maersk-global/mds-design-tokens/maersk/light/web/json/design-tokens.json';
export const getFonts = () => {
  return mdsToken === null || mdsToken === void 0 ? void 0 : mdsToken.brand;
};
export const getCore = () => {
  return mdsToken === null || mdsToken === void 0 ? void 0 : mdsToken.core;
};
export const getTheme = () => {
  return mdsToken === null || mdsToken === void 0 ? void 0 : mdsToken.theme;
};